import './travel-voucher.scss';

import { Outlet } from "react-router-dom";

import { FilterTravelVoucherProvider } from "./filter-travel-voucher/filter-travel-voucher.context";

export function TravelVoucher() {
  return (
    <div id="ShellTravelVoucher" className="travel-voucher">
       <FilterTravelVoucherProvider>
        <Outlet />
      </FilterTravelVoucherProvider>
    </div>
  );
}

export default TravelVoucher;
